module.exports = __webpack_public_path__ + "media/images/hackerrank/qa-641e1a5aa433c6b26f41bacf74457986.png";